<template>
  <div class="box">
    <div class="addTitle">
    <van-form @submit="onSubmit">
        <van-cell-group>
          <!-- <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.empno" placeholder="请输入工号" label="工号"/> -->
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" readonly clickable :value="baseinfo.titletype" label="职称类型" placeholder="请输入职称类型" @click="showTitletype = true,getDict('titletype')"/>
          <van-popup v-model="showTitletype" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConTitletype"
              @cancel="showTitletype = false"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" readonly clickable :value="baseinfo.titlegrade" label="等级" placeholder="请输入等级" @click="showTitlegrade = true,getDict('titlegrade')"/>
          <van-popup v-model="showTitlegrade" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConTitlegrade"
              @cancel="showTitlegrade = false"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.titlename" placeholder="请输入职业资格名称" label="职业资格名称"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.titlegettype" placeholder="请输入职称取得途径" label="职称取得途径"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" type="date" v-model="baseinfo.titlegetdate" placeholder="请输入获得日期" label="获得日期"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.titleno" placeholder="请输入编号" label="编号"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" v-model="baseinfo.files" placeholder="请输入附件" label="附件(图片)"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" v-model="baseinfo.remark" placeholder="请输入备注" label="备注"/>
        </van-cell-group>
        <div class="btnBox">
            <van-button round block type="info" native-type="submit" class="btn">确认</van-button>
        </div>
    </van-form>
    <div class="footer">
      <van-button round block class="btnClo" @click="toInfo">取消</van-button>
    </div>
  </div>
  </div>
</template>

<script>
import api from '@/apis'
import moment from 'moment'
export default {
  name: "addTitle",
  data(){
    return {
      baseinfo:{
        "empno": "", //员工工号
        "titletype": "", //职称类型
        "titlegrade": "", //等级
        "titlename": "", //职业资格名称
        "titlegettype": "", //职称取得途径
        "titlegetdate": "", //获得日期
        "titleno": "", //编号
        "remark": "", //备注
        "files": "", //附件（图片）
      },
      showTitlegrade:false,
      showTitletype:false,
      columns:[],
      itemId:[],
      id:{
        idTitletype:'',
        idTitlegrade:''
      }
    }
  },
  methods: {
    //获取职称类型列表
    getDict(type){
      api.setGetDicts({type}).then((data)=>{
          this.itemId = data.data
          let items = data.data
          this.columns = []
          items.forEach(item=>{
            this.columns.push(item.title)
          })
      })
    },
    //选择职称类型
    onConTitletype(value){
      const str = this.itemId.find(item=>{
        return item.title === value
      })
      this.id.idTitletype = str.id
      this.baseinfo.titletype = value
      this.showTitletype = false
    },
    //选择等级
    onConTitlegrade(value){
      const str = this.itemId.find(item=>{
        return item.title === value
      })
      this.id.idTitlegrade = str.id
      this.baseinfo.titlegrade = value
      this.showTitlegrade = false
    },
    // 提交表单
    onSubmit(){
      let obj = {
        ...this.baseinfo,
        titlegetdate:moment(this.baseinfo.titlegetdate).format('YYYY-MM-DD'),
        titlegrade:this.id.idTitlegrade,
        titletype:this.id.idTitletype,
        table:'euBgtitleList',
        saveType:'1',
        empid:this.$store.state.userInfo.empID,
        empno:this.$store.state.userInfo.empNo
      }
      api.setSaveEmpInfo(obj).then(()=>{
        this.$toast('添加成功');
        this.$router.push({
        path:'/mobile/info',
        query:{
          type:'add'
        }
        })
      })
    },
    //跳转
    toInfo(){
      this.$router.push({
        path:'/mobile/info',
        query:{
          type:'no'
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .addTitle {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .addTitle {
    width: 276px * $zoom;
  }
}
.box{
  display: flex;
  justify-content: center;
}
::v-deep .van-picker__toolbar{
    height: 40px * $zoom;
    .van-picker__cancel{
      font-size: 0.42667rem;
    }
    .van-picker__confirm{
      font-size: 16px * $zoom;
    }
  }
  ::v-deep .van-ellipsis{
    font-size: 8px * $zoom;
  }
.addTitle {
  font-size: 16px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
}
.fromBox{
    height: 90vh;
}
.btnBox{
    width: 50%;
    position: absolute;
    bottom: 20px * $zoom;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px * $zoom 20px * $zoom;
    margin-left: 50%;
}
.btn {
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
}
.footer{
  width: 50%;
  position: absolute;
  bottom: 20px * $zoom;
  display: flex;
  justify-content: flex-end;
  padding: 10px * $zoom 20px * $zoom;
}
.btnClo{
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
  border: none;
}
</style>
